export class CookieService {

    public static setCookie(cname: string, cvalue: string, exdays?: number, pathname?: string) {
        let expires = '';
        if (exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = 'expires=' + d.toUTCString();
        }
        document.cookie = `${cname}=${cvalue};${expires};${pathname ? 'path=' + pathname : ''}`;
    }

    public static getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    }

}